import { Button, Dialog, Intent, Shape } from '@axieinfinity/matcha'
import { LockOpenFillIcon } from '@axieinfinity/matcha-icons'

import imgRonin from '~/public/images/ronin-blue.png'

type TWalletUnlockedModalProps = {
  visible: boolean
  onClose: () => void
}

const WalletUnlockedModal: React.FC<TWalletUnlockedModalProps> = ({
  visible,
  onClose,
}) => {
  return (
    <Dialog
      className="[&_.dango-dialog-content]:bg-surface-color-default [&_.dango-dialog-content]:border [&_.dango-dialog-content]:border-border-color-default [&_.dango-dialog-body]:p-0 [&_.dango-dialog-content]:!p-0 p-16 !w-[390px] sm:!w-[480px]"
      visible={visible}
      onClose={onClose}
      destroyOnClose
      size="small"
    >
      <div className="flex flex-col items-center text-center">
        <div className="relative mt-20 mb-24">
          <img width={105} height={105} src={imgRonin} alt="warning" />
          <div className="absolute" style={{ right: 0, bottom: -12 }}>
            <LockOpenFillIcon size={32} />
          </div>
        </div>

        <div className="text-large leading-28 mb-4 font-semibold">
          Unlock Ronin Wallet
        </div>
        <div className="text-normal leading-20 text-text-color-subdued mb-24 font-medium">
          Please unlock your Ronin Wallet to perform this action.
        </div>

        <Button
          onClick={onClose}
          text="Got it"
          shape={Shape.Default}
          intent={Intent.Primary}
        />
      </div>
    </Dialog>
  )
}

export default WalletUnlockedModal
